export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="text-xl font-heading text-background-100 mb-4 block">51漫画</span>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed">
              51漫画在线观看为您提供海量免费漫画全集在线阅读服务，支持下拉式阅读与实时更新，无需下载即可畅享热门漫画大全。涵盖热血、恋爱、奇幻、悬疑等全品类在线漫画，是漫画爱好者的首选在线阅读平台。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <div className="space-y-2">
              <a href="#index" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">漫画分类</a>
              <a href="#features" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">平台特色</a>
              <a href="#ranking" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门排行</a>
              <a href="#updates" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新动态</a>
              <a href="#faq" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">热门分类</h3>
            <div className="space-y-2">
              <a href="#topics" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">热血漫画</a>
              <a href="#topics" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">恋爱漫画</a>
              <a href="#topics" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">奇幻漫画</a>
              <a href="#topics" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">悬疑漫画</a>
              <a href="#topics" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">古风漫画</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed">
              51漫画在线与多家知名漫画平台及原创漫画工作室保持合作，持续为用户提供优质的免费漫画在线阅读服务。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 51漫画在线观看. 本站所有漫画资源均来自合法授权渠道。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">51漫画在线</span>
            <span className="text-xs text-background-500">在线漫画</span>
            <span className="text-xs text-background-500">免费漫画</span>
          </div>
        </div>
      </div>
    </footer>
  );
}